import React from 'react';

const Vessels = () => {
  const pumpProducts = [
  
    { name: "FRP vessels", image: "/images/jalistep/pic7.jpg" }
    
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-5 text-dark"> FRP Vessels</h1>
      
      <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
        {pumpProducts.map((product, index) => (
          <div key={index} className="col">
            <div className="card h-100 shadow-sm border-0 text-center">
              <img 
                src={product.image} 
                alt={product.name}
                className="card-img-top p-3"
                style={{ 
                  height: "200px", 
                  objectFit: "contain",
                  backgroundColor: "#f8f9fa" // Light background for better visibility
                }}
              />
              <div className="card-body">
                <h5 className="card-title text-cyan m-0">{product.name}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Vessels;